
/**
 * This file is auto-generated by the `asana-api-meta` NodeJS package.
 * We try to keep the generated code pretty clean but there will be lint
 * errors that are just not worth fixing (like unused requires).
 * TODO: maybe we can just disable those specifically and keep this code
 * pretty lint-free too!
 */
/* jshint ignore:start */
var Resource = require('../resource');
var util = require('util');
var _ = require('lodash');

/**
 * A _job_ represents a process that handles asynchronous work.
 *
 * Jobs are created when an endpoint requests an action that will be handled asynchronously.
 * Such as project or task duplication.
 * @class
 * @param {Dispatcher} dispatcher The API dispatcher
 */
function Jobs(dispatcher) {
  Resource.call(this, dispatcher);
}
util.inherits(Jobs, Resource);


/**
 * Returns the complete job record for a single job.
   * @param {String} job The job to get.
   * @param {Object} [params] Parameters for the request
   * @param {Object} [dispatchOptions] Options, if any, to pass the dispatcher for the request
   * @return {Promise} The requested resource
 */
Jobs.prototype.findById = function(
    job,
    params,
    dispatchOptions
) {
  var path = util.format('/jobs/%s', job);

  return this.dispatchGet(path, params, dispatchOptions);
};


module.exports = Jobs;
/* jshint ignore:end */



//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/resources/gen/jobs.js
// module id = 1447
// module chunks = 0